import { IOrder } from '@/interfaces/order';
import { formatNumber } from '@/utils/dataUtils';
import React from 'react';
import { IPackingList } from '@/interfaces/packingList';

interface IProps {
  data: IOrder;
  packingLists: IPackingList[];
  isMultiPage?: boolean;
  netWeight?: number;
  grossWeight?: number;
  totalPackage?: number;
  totalItem?: number;
}

const TemplatePackingLIst = ({
  data,
  packingLists,
  isMultiPage = false,
  netWeight,
  grossWeight,
  totalPackage,
  totalItem,
}: IProps) => {
  const unitName =
    (data?.orderItems && data?.orderItems[0]?.packageUnitName) || '';

  return (
    <>
      <div className="flex w-full text-xs mt-2">
        <table
          border={1}
          cellSpacing={0}
          cellPadding={5}
          style={{
            width: '100%',
            border: '0.5px; black solid',
            borderCollapse: 'collapse',
            // height: 360,
          }}
        >
          <tr style={{ height: 45 }}>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>DESCRIPTION</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={110}
            >
              <strong>LOT NUMBER</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={70}
            >
              <strong>
                QUANTITY <br /> (KG)
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={70}
            >
              <strong>PACKAGES</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={90}
            >
              <strong> PLTS x PACK x KG/PACK</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={90}
            >
              <strong>
                NET WEIGHT
                <br />
                (KG)
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={100}
            >
              <strong>
                GROSS WEIGHT
                <br /> (KGS)
              </strong>
            </td>
          </tr>
          {packingLists?.map(i => {
            return (
              <tr key={i.id}>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {i.packingListItems?.map(p => {
                    return <p key={p.id}>{p.productName}</p>;
                  })}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {i.packingListItems?.map(p => {
                    return <p key={p.id}>{p.lotNumber}</p>;
                  })}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                >
                  {i.packingListItems?.map(p => {
                    return <p key={p.id}>{formatNumber(p.quantity || 0, 0)}</p>;
                  })}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                >
                  {i.packingListItems?.map(p => {
                    return <p key={p.id}>{formatNumber(p.package || 0, 0)}</p>;
                  })}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {i.dimension}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                >
                  {formatNumber(Number(i.netWeight), 2)}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                >
                  {formatNumber(Number(i.grossWeight), 2)}
                </td>
              </tr>
            );
          })}
          {!isMultiPage && (
            <>
              <tr>
                <td
                  style={{
                    border: '1px solid black',
                    verticalAlign: 'middle',
                  }}
                  colSpan={1}
                >
                  <p className="font-lg font-bold">{`Total : ${totalItem || 0} pallets (${totalPackage} ${unitName})`}</p>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    verticalAlign: 'middle',
                  }}
                  colSpan={6}
                >
                  <p className="font-lg font-bold">{data?.exportType || ''}</p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                    verticalAlign: 'middle',
                  }}
                  colSpan={5}
                >
                  <p className="font-lg font-bold">TOTAL VALUE</p>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    borderRight: '1px solid black',
                    textAlign: 'right',
                    verticalAlign: 'middle',
                  }}
                  colSpan={1}
                >
                  <p className="font-lg font-bold">
                    {formatNumber(netWeight || 0, 2)}
                  </p>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    borderRight: '1px solid black',
                    textAlign: 'right',
                    verticalAlign: 'middle',
                  }}
                  colSpan={1}
                >
                  <p className="font-lg font-bold">
                    {formatNumber(grossWeight || 0, 2)}
                  </p>
                </td>
              </tr>
            </>
          )}
        </table>
      </div>
    </>
  );
};

export default TemplatePackingLIst;
